import React from "react";
import { AvisoPalletsOcultos } from "../../ProduccionV2/components/AvisoPalletsOcultos";

// Pallets que no aparecen en las existencias porque ingresaron a bodega
// después de la fecha y hora del reloj de bodega
export const AvisoPalletsIngresadosDespues = ({ pallets }) => (
    <AvisoPalletsOcultos
        pallets={pallets}
        motivoSingular="ingresó a bodega después de la fecha y hora del reloj de bodega"
        motivoPlural="ingresaron a bodega después de la fecha y hora del reloj de bodega"
    />
);
